import ResetTvIcon from "./icons/reset-tv.svg?react";

export interface ReturnButtonProps {
  onClick: () => void;
  visible: boolean;
}

/**
 * Return button for desktop - resets camera to home position
 * Hidden on mobile devices (functionality is in ControlOverlay)
 */
export function ReturnButton({ onClick, visible }: ReturnButtonProps) {
  return (
    <>
      <button
        type="button"
        className="return-button"
        onClick={onClick}
        style={{
          position: "fixed",
          bottom: 40,
          left: "50%",
          transform: "translateX(-50%)",
          padding: "12px 24px",
          fontSize: 14,
          fontWeight: 600,
          color: "#fff",
          background: "rgba(100, 120, 255, 0.1)",
          border: "1px solid rgba(100, 120, 255, 0.5)",
          borderRadius: 8,
          cursor: "pointer",
          transition: "opacity 0.4s ease, background 0.2s ease",
          backdropFilter: "blur(8px)",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
          display: "flex",
          alignItems: "center",
          opacity: visible ? 1 : 0,
          pointerEvents: visible ? "auto" : "none",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(100, 120, 255, 0.3)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "rgba(100, 120, 255, 0.1)";
        }}
      >
        <ResetTvIcon />
      </button>

      {/* Hide on mobile - ControlOverlay handles this functionality */}
      <style>
        {`
          @media (max-width: 768px), (hover: none) and (pointer: coarse) {
            .return-button {
              display: none !important;
            }
          }
        `}
      </style>
    </>
  );
}
